import script from "./SyncMethodPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncMethodPage.vue?vue&type=script&setup=true&lang=ts"

import "./SyncMethodPage.vue?vue&type=style&index=0&id=324536fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324536fa"]])

export default __exports__